"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.container = typestyle_1.style({
  width: "100%"
});

exports.title = function (fontFamily, color) {
  return typestyle_1.style({
    fontFamily: fontFamily
  }, {
    color: color
  }, {
    fontSize: "16px"
  }, {
    fontWeight: 500
  }, {
    marginBottom: "8px"
  });
};